// Evenements ecommerce GA4 (add_to_cart / begin_checkout) pousses dans dataLayer pour GTM.
// Shopify envoie deja nativement view_item (Web Pixel "Google & YouTube") mais rien pour
// add_to_cart/begin_checkout : ce fichier comble ce trou (backlog SEO/analytics #35).
(function () {
  'use strict';

  function pushEcommerceEvent(eventName, items, currency) {
    if (!items || !items.length) return;
    var value = items.reduce(function (sum, item) {
      return sum + (Number(item.price) || 0) * (Number(item.quantity) || 1);
    }, 0);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: eventName,
      ecommerce: {
        currency: currency || 'EUR',
        value: Math.round(value * 100) / 100,
        items: items
      }
    });
  }

  // Normalise une reponse Shopify /cart/add.js (format plat single-item ou {items:[...]})
  // vers le format d'items GA4 recommande.
  function itemsFromCartResponse(raw) {
    if (!raw) return [];
    var list = Array.isArray(raw.items) ? raw.items : [raw];
    return list
      .filter(function (i) { return i && (i.variant_id || i.id); })
      .map(function (i) {
        return {
          item_id: String(i.variant_id || i.id),
          item_name: i.product_title || i.title || '',
          price: (i.price || i.final_price || 0) / 100,
          quantity: i.quantity || 1,
          item_brand: i.vendor || undefined
        };
      });
  }

  window.QnGA4 = {
    push: pushEcommerceEvent,
    itemsFromCartResponse: itemsFromCartResponse
  };

  function initAddToCartTracking() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form' || !event.cartData || event.cartData.status) return;
      pushEcommerceEvent('add_to_cart', itemsFromCartResponse(event.cartData), 'EUR');
    });
  }

  function initBeginCheckoutTracking() {
    document.body.addEventListener('submit', function (e) {
      var submitter = e.submitter;
      if (!submitter || submitter.name !== 'checkout') return;
      var form = e.target;
      if (form.dataset.qnCheckoutTracked === '1') return;
      e.preventDefault();
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = (cart.items || []).map(function (i) {
            return {
              item_id: String(i.variant_id),
              item_name: i.product_title,
              price: (i.price || 0) / 100,
              quantity: i.quantity,
              item_brand: i.vendor
            };
          });
          pushEcommerceEvent('begin_checkout', items, cart.currency || 'EUR');
        })
        .catch(function () {})
        .finally(function () {
          form.dataset.qnCheckoutTracked = '1';
          if (form.requestSubmit) { form.requestSubmit(submitter); } else { form.submit(); }
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAddToCartTracking();
    initBeginCheckoutTracking();
  });
})();
